/**
 * Reads the account-scoped user list with a single-row page, to read `totalRecords` only: how many
 * users are still configured for password sign-in, invitations included. `authenticationMode` is sent
 * twice, once per password variant (`password_only`, `password_and_second_factor`) — the server filter
 * accepts a repeated parameter and treats it as `in`. `rows` matches this project's pagination
 * convention (`AbstractFiltersDto`), not the `limit` word used in prose.
 */
class FetchPasswordSignInUserCount {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}

	get queryParams(): URLSearchParams {
		const params = new URLSearchParams();
		params.append('authenticationMode', 'password_only');
		params.append('authenticationMode', 'password_and_second_factor');
		params.set('isActive', 'true');
		params.set('rows', '1');
		return params;
	}
}

export default FetchPasswordSignInUserCount;
